import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

export async function getConfig () {
  const res = await firebase.database().ref('config').once('value')
  return res.val()
}
